import React, { useState } from 'react';
import { useTeam } from './TeamContext';

const Episode2 = () => {
  const { team } = useTeam();

  return (
    <div>
      <div className="mt-4">
        <div>
          <h2 className="font-lustra text-3xl text-white text-center mb-8">
          Episodio 2: El Laberinto del Desorden Cósmico
          </h2>
          <div className="mt-2 mb-2 text-lg space-y-4 text-white">
            <p>
              No todo lo que brilla es oro... y no todo dashboard sin errores significa que todo está bien.
              Lamentablemente, nuestros ingenieros aún no han logrado domar los caprichos de la radiación cósmica.
              Esos impredecibles vientos estelares y destellos de materia oscura aparentemente siguen burlándose
              de nuestras métricas y logs.
            </p>
            <p>
              Como consecuencia, los circuitos donde se ejecuta este código pueden experimentar
              alteraciones inesperadas: comportamientos erráticos, datos distorsionados, y,
              en ocasiones, pagos que desafían la lógica misma del continuo espacio-tiempo.
            </p>
            <p>
              ¿Serán los efectos de las ondas gravitacionales perturbando las transmisiones?
              ¿O quizá estamos presenciando pagos que llegan desde otras dimensiones más allá
              de lo que jamás habríamos imaginado? Nadie lo sabe con certeza. Lo que sí es
              seguro es que cada equipo necesitará creatividad, rapidez y, por supuesto,
              nervios de acero para enfrentarse a estas anomalías intergalácticas.
            </p>
            <p>
              Así que no se sorprendan si en algún momento algo que parece funcionar... de pronto no lo hace.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Episode2;
